// Lightweight region preferences (saved to localStorage).
// Used by Streaming On row + provider filter for movies.

import { useEffect, useState } from "react";

export const REGIONS = [
  { code: "US", name: "United States", flag: "🇺🇸" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧" },
  { code: "CA", name: "Canada",        flag: "🇨🇦" },
  { code: "AU", name: "Australia",     flag: "🇦🇺" },
  { code: "IE", name: "Ireland",       flag: "🇮🇪" },
  { code: "DE", name: "Germany",       flag: "🇩🇪" },
  { code: "FR", name: "France",        flag: "🇫🇷" },
  { code: "ES", name: "Spain",         flag: "🇪🇸" },
  { code: "IT", name: "Italy",         flag: "🇮🇹" },
  { code: "NL", name: "Netherlands",   flag: "🇳🇱" },
  { code: "JP", name: "Japan",         flag: "🇯🇵" },
  { code: "BR", name: "Brazil",        flag: "🇧🇷" },
  { code: "MX", name: "Mexico",        flag: "🇲🇽" },
  { code: "IN", name: "India",         flag: "🇮🇳" },
];

const KEY = "tt:watchRegion";

export function getRegion() {
  try {
    const v = localStorage.getItem(KEY);
    if (v && REGIONS.find((r) => r.code === v)) return v;
  } catch (_) { /* noop */ }
  return "US";
}

export function setRegion(code) {
  try { localStorage.setItem(KEY, code); } catch (_) { /* noop */ }
  try { window.dispatchEvent(new CustomEvent("tt:regionchange", { detail: code })); } catch (_) { /* noop */ }
}

export function useRegion() {
  const [r, setR] = useState(getRegion());
  useEffect(() => {
    const handler = (e) => setR(e?.detail || getRegion());
    window.addEventListener("tt:regionchange", handler);
    return () => window.removeEventListener("tt:regionchange", handler);
  }, []);
  return r;
}
